import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/sessions/session-1/session-1-logo.png'
import _imports_1 from '../../assets/sessions/session-2-logo.png'
import _imports_2 from '../../assets/sessions/session-3/session-3-logo.png'
import _imports_3 from '../../assets/sessions/session-4-logo.png'
import _imports_4 from '../../assets/sessions/session-5/session-5-logo.png'
import _imports_5 from '../../assets/brand/gyre-icon-sm-rounded.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-aeef4636"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background-visuals title-visuals" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Scroll down"),
  /*#__PURE__*/_createElementVNode("span", { class: "session-wide-only" }, " or tap the arrow keys")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "session-inline-only" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "session-inline-only" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "session-inline-only" }, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  ref: "initialLogoForPositioningVisual",
  class: "visual side-visual initial-logo-for-positioning"
}

import { TimelineLite, TimelineMax } from "gsap";
import { getCurrentInstance, onMounted, ref } from "vue";

const titleTimescale = 1;


export default /*#__PURE__*/_defineComponent({
  __name: 'title-visuals',
  props: {
    sessionTitle: {},
    sessionLogoImageSrc: {},
    sessionNumber: {}
  },
  setup(__props: any, { expose: __expose }) {

const instance = getCurrentInstance()?.proxy;
const session = instance?.$parent;
const props = __props;

const logoRect = ref<DOMRect | null>(null);

const initialLogoForPositioningImage = ref<Element | null>(null);
const initialLogoImage = ref<Element | null>(null);
const initialSessionLogoImage = ref<Element | null>(null);
const guidanceVisual = ref<Element | null>(null);
const titleBarVisual = ref<Element | null>(null);
const textWhiteOverlay = ref<Element | null>(null);
const titleVisual = ref<Element | null>(null);
const initialLogoVisual = ref<Element | null>(null);

onMounted(() => {
  logoRect.value = (initialLogoForPositioningImage.value as HTMLElement).getBoundingClientRect();
});

const sessionLogoIn = (tl: TimelineMax): TimelineLite =>
  tl
    .to(
      initialLogoImage.value!,
      titleTimescale,
      { autoAlpha: 0, ease: (session as any).titleTextEase },
      0,
    )
    .to(
      initialSessionLogoImage.value!,
      titleTimescale,
      { autoAlpha: 1, ease: (session as any).titleTextEase },
      0,
    );

const sessionLogoOut = (
  tl: TimelineMax,
  reduceSizeDuringFade = false,
): TimelineLite | undefined => {
  if (!initialSessionLogoImage.value) return;

  return tl.to(
    initialSessionLogoImage.value,
    titleTimescale,
    {
      autoAlpha: 0,
      scale: reduceSizeDuringFade ? 0.7 : 1,
      ease: (session as any).titleTextEase,
    },
    0,
  );
};

const leave = (tl: TimelineMax): void =>
  (session as any).zoomLeave(tl, [initialLogoImage.value!, initialSessionLogoImage.value!]);

const sessionLogoRotateOut = (tl: TimelineMax): TimelineLite =>
  tl.to(
    initialSessionLogoImage.value!,
    titleTimescale,
    { autoAlpha: 0, rotation: 180, ease: (session as any).titleTextEase },
    0,
  );

const rollIn = (tl: TimelineMax, switchToCsLogo = true): void => {
  logoRect.value = (initialLogoForPositioningImage.value as HTMLElement).getBoundingClientRect();

  tl.to(
    initialLogoVisual.value!,
    titleTimescale,
    {
      top: logoRect.value.top,
      left: logoRect.value.left,
      width: logoRect.value.width,
      height: logoRect.value.height,
      ease: (session as any).titleVisualEase,
    },
    0,
  )
    .to(
      initialLogoVisual.value!,
      titleTimescale,
      {
        css: { className: "+=transitioned" },
        autoCss: true,
        overwrite: "none",
        ease: (session as any).titleVisualEase,
      },
      0,
    )
    .to(
      titleBarVisual.value!,
      titleTimescale,
      { top: -200, bottom: -200, ease: (session as any).titleVisualEase },
      0,
    )
    .to(
      textWhiteOverlay.value!,
      titleTimescale,
      { autoAlpha: 1, ease: (session as any).titleVisualEase },
      0,
    )
    .to(
      titleVisual.value!,
      titleTimescale,
      { autoAlpha: 0, ease: (session as any).titleTextEase },
      0,
    );

  if (switchToCsLogo) {
    tl.to(
      initialLogoImage.value!,
      titleTimescale,
      { autoAlpha: 1, ease: (session as any).titleTextEase },
      0,
    ).to(
      initialSessionLogoImage.value!,
      titleTimescale,
      { autoAlpha: 0, ease: (session as any).titleTextEase },
      0,
    );
  }

  tl.to(
    guidanceVisual.value!,
    titleTimescale * 0.3,
    { autoAlpha: 0, marginTop: -70, ease: (session as any).titleVisualEase },
    0,
  );
};

function fadeOutOverlay(tl: TimelineMax): void {
  tl.to(titleBarVisual.value!, titleTimescale, { autoAlpha: 0 }, 0);
}

function fadeInOverlay(tl: TimelineMax, timescale: number = titleTimescale): void {
  tl.to(titleBarVisual.value!, timescale, { autoAlpha: 1 }, 0);
}

__expose({
  sessionLogoIn,
  sessionLogoOut,
  leave,
  sessionLogoRotateOut,
  rollIn,
  fadeOutOverlay,
  fadeInOverlay,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "guidanceVisual",
      ref: guidanceVisual,
      class: "visual guidance-visual show"
    }, _hoisted_3, 512),
    _createElementVNode("div", {
      ref_key: "titleBarVisual",
      ref: titleBarVisual,
      class: "visual show title-bar-visual"
    }, [
      _createElementVNode("div", {
        ref_key: "textWhiteOverlay",
        ref: textWhiteOverlay,
        class: "text-white-overlay session-wide-only",
        style: {"opacity":"0"}
      }, null, 512)
    ], 512),
    _createElementVNode("div", {
      ref_key: "titleVisual",
      ref: titleVisual,
      class: "visual show title-visual",
      "data-test": "session-title"
    }, [
      (_ctx.sessionTitle)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.sessionTitle), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("Mapping your"),
            _hoisted_4,
            _createTextVNode(" Strengths")
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 2)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode("Your Solo"),
            _hoisted_5,
            _createTextVNode(" Report")
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 3)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createTextVNode("Others' views")
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 4)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _createTextVNode("Your Viewpoints"),
            _hoisted_6,
            _createTextVNode(" Report")
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 5)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
            _createTextVNode("Engage")
          ], 64))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", {
      ref_key: "initialLogoVisual",
      ref: initialLogoVisual,
      class: "visual show initial-logo-visual"
    }, [
      (_ctx.sessionLogoImageSrc)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            ref_key: "initialSessionLogoImage",
            ref: initialSessionLogoImage,
            src: _ctx.sessionLogoImageSrc,
            alt: "Session Logo"
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            ref_key: "initialSessionLogoImage",
            ref: initialSessionLogoImage,
            src: _imports_0,
            alt: "Session 1 Logo",
            class: "session-1-logo"
          }, null, 512))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 2)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            ref_key: "initialSessionLogoImage",
            ref: initialSessionLogoImage,
            src: _imports_1,
            alt: "Session 2 Logo",
            class: "session-2-logo"
          }, null, 512))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 3)
        ? (_openBlock(), _createElementBlock("img", {
            key: 3,
            ref_key: "initialSessionLogoImage",
            ref: initialSessionLogoImage,
            src: _imports_2,
            alt: "Session 3 Logo",
            class: "session-3-logo"
          }, null, 512))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 4)
        ? (_openBlock(), _createElementBlock("img", {
            key: 4,
            ref_key: "initialSessionLogoImage",
            ref: initialSessionLogoImage,
            src: _imports_3,
            alt: "Session 4 Logo",
            class: "session-4-logo"
          }, null, 512))
        : _createCommentVNode("", true),
      (_ctx.sessionNumber == 5)
        ? (_openBlock(), _createElementBlock("img", {
            key: 5,
            ref_key: "initialSessionLogoImage",
            ref: initialSessionLogoImage,
            src: _imports_4,
            alt: "Session 5 Logo",
            class: "session-5-logo"
          }, null, 512))
        : _createCommentVNode("", true),
      _createElementVNode("img", {
        ref_key: "initialLogoImage",
        ref: initialLogoImage,
        src: _imports_5,
        alt: "Gyre Logo",
        class: "session-jyre-logo",
        style: {"opacity":"0"}
      }, null, 512)
    ], 512),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("img", {
        ref_key: "initialLogoForPositioningImage",
        ref: initialLogoForPositioningImage,
        src: _imports_1,
        alt: "Gyre circles logo",
        style: {"margin":"0 auto","width":"50%"}
      }, null, 512)
    ], 512)
  ]))
}
}

})